import React from "react";
import { Formik } from "formik";
import { View, Text, ScrollView } from "react-native";
import Button from "../../forms/button";
import TextInput from "../../forms/textInput";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import registerPushNotifications from "../../notifications/push/register";
import { attributes } from "../../theme";
import styled from "styled-components/native";

import { Theme } from "../../theme";
import currentGame from "../currentGame";

interface BuildLevelsProps {
  createGame: any;
  navigation: any;
}

interface Levels {
  easy: Level;
  medium: Level;
  hard: Level;
}

interface Level {
  drinks: Array<string>;
}

interface CurrentDrinks {
  easy: string;
  medium: string;
  hard: string;
}

interface BuildLevelsState {
  isSubmitting: boolean;
  isValid: boolean;
  name: string;
  gameTime: number;
  difficulty: number;
  levels: Levels;
  currentDrinks: CurrentDrinks;
}

const Container = styled.View`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 500px;
`;

const SelectedDrinksContainer = styled.View`
  max-width: 600px;
  width: 100%;
`;

const SelectedDrinkContainer = styled.View`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 20px;
  align-items: center;
`;

const LevelText = styled.Text`
  font-size: 30px;
  color: ${attributes.mainColor};
`;

const ActionContainer = styled.View`
  margin-bottom: 20px;
  width: 175px;
`;

const ActionView = styled.View`
  margin: 10px 0;
`;

const NewDrinkContainer = styled.View`
  text-align: center;
  width: 155px;
`;

export class BuildLevels extends React.Component<
  BuildLevelsProps,
  BuildLevelsState
> {
  constructor(props) {
    super(props);

    const newGame = global.NewGame;
    const levels = {
      easy: {
        drinks: [],
      },
      medium: {
        drinks: [],
      },
      hard: {
        drinks: [],
      },
    };

    // const newGame = {
    //   playerName: "Josh",
    //   gameTime: 60,
    //   difficulty: 5,
    // };

    // const levels = {
    //   easy: {
    //     drinks: ["A juice"],
    //   },
    //   medium: {
    //     drinks: ["A beer"],
    //   },
    //   hard: {
    //     drinks: ["A shot of tequila"],
    //   },
    // };

    this.state = {
      isSubmitting: false,
      isValid: true,
      name: newGame.playerName,
      gameTime: newGame.gameTime,
      difficulty: newGame.difficulty,
      currentDrinks: {
        easy: "",
        medium: "",
        hard: "",
      },
      levels,
    };
  }

  static navigationOptions = {
    title: "Build levels",
  };

  handleSubmit = async () => {
    this.setState(
      {
        isSubmitting: true,
      },
      async () => {
        try {
          const pushToken = await registerPushNotifications();

          const result = await this.props.createGame({
            variables: {
              name: this.state.name,
              owner: { id: this.state.name, pushToken },
              levels: this.state.levels,
              gameTime: this.state.gameTime,
              difficulty: this.state.difficulty,
            },
          });
          global.RunningGame = {
            game: result.data.createGame,
            name: this.state.name,
          };
          this.setState({
            isSubmitting: false,
          });
          this.props.navigation.navigate("CurrentGame");
        } catch (error) {
          console.log(error.stack);
          this.setState({
            isSubmitting: false,
          });
          throw error;
        }
      }
    );
  };

  handleDrinkChange = (levelType, drink) => {
    const currentDrinks = this.state.currentDrinks;
    currentDrinks[levelType] = drink;

    this.setState({
      currentDrinks,
    });
  };

  handleAddDrink = (levelType) => {
    const levels = this.state.levels;
    levels[levelType].drinks.push(this.state.currentDrinks[levelType]);

    const currentDrinks = this.state.currentDrinks;
    currentDrinks[levelType] = "";

    this.setState(
      {
        levels,
        currentDrinks,
      },
      () => {
        this.validate();
      }
    );
  };

  handleRemoveDrink = (levelType, index) => {
    const levels = this.state.levels;

    levels[levelType].drinks.splice(index, 1);

    this.setState(
      {
        levels,
      },
      () => {
        this.validate();
      }
    );
  };

  validate = () => {
    this.setState({
      isValid:
        this.state.levels.easy.drinks.length > 0 &&
        this.state.levels.medium.drinks.length > 0 &&
        this.state.levels.hard.drinks.length > 0,
    });
  };

  render() {
    const drinkContent = Object.keys(this.state.levels).map((levelType) => {
      const levelTypeDisplay =
        levelType.charAt(0).toUpperCase() + levelType.substring(1);
      const level = this.state.levels[levelType];

      const currentDrinks = level.drinks.map((drink, index) => {
        const drinkContainerStyles = {};

        drinkContainerStyles.backgroundColor =
          index % 2 === 0
            ? attributes.backgroundColor
            : attributes.secondaryBackgroundColor;

        const selectedButtonStyles = { width: 50 };
        selectedButtonStyles.backgroundColor =
          drinkContainerStyles.backgroundColor;

        return (
          <SelectedDrinkContainer key={index} style={drinkContainerStyles}>
            <Text style={{ fontSize: 22 }}>{drink}</Text>
            <Button
              raised={false}
              title="x"
              buttonStyle={selectedButtonStyles}
              titleStyle={{ color: attributes.mainColor, fontSize: 24 }}
              containerStyle={{ width: 50 }}
              onPress={() => this.handleRemoveDrink(levelType, index)}
            />
          </SelectedDrinkContainer>
        );
      });

      return (
        <View>
          <Text>{levelTypeDisplay} drinks</Text>
          {currentDrinks}
          <NewDrinkContainer>
            <TextInput
              field={{
                name: "addDrink",
                onChange: () => (drink) =>
                  this.handleDrinkChange(levelType, drink),
                onBlur: () => null,
                value: this.state.currentDrinks[levelType],
              }}
              placeholder="New drink"
              width={175}
              style={{ color: attributes.mainColor }}
              form={{ errors: [] }}
              inputStyle={{
                textAlign: "center",
                width: 155,
              }}
            />
          </NewDrinkContainer>
          <ActionView>
            <Button
              title="Add drink"
              disabled={!this.state.currentDrinks}
              onPress={() => this.handleAddDrink(levelType)}
              buttonStyle={{
                backgroundColor: attributes.backgroundColor,
              }}
              titleStyle={{ color: attributes.mainColor }}
            />
          </ActionView>
        </View>
      );
    });

    return (
      <Theme>
        <Formik
          onSubmit={() => {
            this.handleSubmit();
          }}
          render={({ handleSubmit }) => (
            <ScrollView>
              <Container>
                <SelectedDrinksContainer>
                  {drinkContent}
                </SelectedDrinksContainer>
                <ActionContainer>
                  <View>
                    <ActionView>
                      <Button
                        disabled={
                          !this.state.isValid || this.state.isSubmitting
                        }
                        title="Create Game!"
                        onPress={handleSubmit}
                      />
                    </ActionView>
                  </View>
                </ActionContainer>
              </Container>
            </ScrollView>
          )}
        />
      </Theme>
    );
  }
}

const CREATE_GAME_MUTATION = gql`
  mutation createGameMutation(
    $name: String!
    $owner: OwnerInput!
    $levels: LevelInput!
    $gameTime: Int!
    $difficulty: Int!
  ) {
    createGame(
      name: $name
      owner: $owner
      levels: $levels
      gameTime: $gameTime
      difficulty: $difficulty
    ) {
      id
      status
      owner {
        id
      }
      levelDrinks {
        easy {
          drinks
        }
        medium {
          drinks
        }
        hard {
          drinks
        }
      }
      gameTime
      difficulty
    }
  }
`;

const BuildLevelsWithMutation = graphql(CREATE_GAME_MUTATION, {
  name: "createGame",
})(BuildLevels);

export default BuildLevelsWithMutation;
